import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE, timeout: 15000 });

export const fetchServices = () => api.get("/services");
export const fetchService = (slug) => api.get(`/services/${slug}`);
export const fetchLawyers = () => api.get("/lawyers");
export const fetchTestimonials = () => api.get("/testimonials");
export const fetchPosts = () => api.get("/posts");
export const fetchPost = (slug) => api.get(`/posts/${slug}`);
export const fetchFaqs = () => api.get("/faqs");
export const fetchCase = (code) => api.get(`/cases/${encodeURIComponent(code)}`);
export const submitConsultation = (data) => api.post("/consultations", data);
export const submitContact = (data) => api.post("/contact", data);

export default api;
